<template>
  <div
    class="screen-adapter"
    :style="style"
  >
    <slot />
  </div>
</template>
<script>
import screenfull from 'screenfull/dist/screenfull';

export default {
  name: '',
  // 参数注入
  props: {
    width: {
      type: String,
      default: '1920',
    },
    height: {
      type: String,
      default: '1080',
    },
  },
  data() {
    return {
      isFullScreen: false,
      style: {
        width: `${this.width}px`,
        height: `${this.height}px`,
        transform: 'scale(1) translate(-50%, -50%)',
      },
    };
  },
  watch: {
    height(val) {
      this.style.height = `${val}px`;
    },
  },
  mounted() {
    this.setScale();
    window.onresize = this.Debounce(this.setScale, 0);
    if (screenfull.enabled) {
      screenfull.on('change', () => {
        this.isFullScreen = !this.isFullScreen;
      });
    }
  },
  methods: {
    Debounce: (fn, t) => {
      const delay = t;
      let timer;
      // eslint-disable-next-line func-names
      return function () {
        // eslint-disable-next-line prefer-rest-params
        const args = arguments;
        if (timer) {
          clearTimeout(timer);
        }
        const context = this;
        timer = setTimeout(() => {
          timer = null;
          fn.apply(context, args);
        }, delay);
      };
    },
    // 获取放大缩小比例
    getScale() {
      const w = window.innerWidth / this.width;
      const h = window.innerHeight / this.height;
      return w < h ? w : h;
    },
    // 设置比例
    setScale() {
      if (!this.isFullScreen) {
        this.style.transform = `scale(${this.getScale()}) translate(-50%, 0)`;
      } else {
        this.style.transform = `scale(${this.getScale()}) translate(-50%, -50%)`;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.screen-adapter {
  transform-origin: 0 0;
  position: absolute;
  left: 50%;
  top: 50%;
  transition: 0.3s;
}
</style>
